import { SubPageShell } from "@/components/SubPageShell";
import { Location } from "@/components/Location";

export default function LocationPage() {
  return (
    <SubPageShell
      eyebrow="Location"
      title={<>In the heart of <em>Muri Beach.</em></>}
      intro="Ata House is tucked into Muri — Rarotonga's most beloved stretch of lagoon. A short walk to the beach, cafés, restaurants, and the island's gentlest snorkelling spots."
    >
      <Location hideHeader />
    </SubPageShell>
  );
}
